import {
  LOGIN_USER_DETAILS,
  LOGIN_USER_DETAILS_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  LOGIN_USER_DETAILS_ERROR,
  PASSWORD_RESET_ERROR,
  PASSWORD_RESET_SUCCESS,
  LINK_DETAILS_SUCCESS,
  PASSWORD_CREATE_SUCCESS,
} from '../actions/LoginActions'

const initialState = {
  loginError: '',
  message: null,
  loading: false,
  loginDetails: {},
  userLogged:false
}

const loginReducer = function (state = initialState, action) {
  switch (action.type) {
    case LOGIN_USER_DETAILS: {
      state = {
        ...state,
        loading: true,
      }
      break
    }
    case LOGIN_USER_DETAILS_SUCCESS:
      state = {
        ...state,
        loading: false,
        loginDetails: action.payload,
      }
      break
    case PASSWORD_RESET_SUCCESS:
      state = {
        ...state,
        loading: false,
        resetMessage: action.payload,
      }
      break
    case PASSWORD_RESET_ERROR:
      state = {
        ...state,
        loading: false,
        resetError: action.payload,
      }
      break
    case LINK_DETAILS_SUCCESS:
      state = {
        ...state,
        loading: false,
        linkDetails: action.payload,
      }
    break
    case PASSWORD_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        createMessage: action.payload,
      }
    break
    case LOGOUT_USER:
      state = {}
      break
    case LOGOUT_USER_SUCCESS:
      state = { 
        ...state,
        userLogged:false,
       }
      break
    case LOGIN_USER_DETAILS_ERROR:
      state = {
        ...state,
        loading: false,
        loginError: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}
export default loginReducer
